module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('div', {
    staticClass: "panel-body",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleClick($event)
      }
    }
  }, [_vm._c('div', {
    staticClass: "microNoteStudier"
  }, [_vm._c('div', {
    staticClass: "html"
  }, [(_vm.microNote) ? _vm._c('DynamicRenderer', {
    ref: "html",
    attrs: {
      "html": _vm.microNote.html
    }
  }) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b4f2c59c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-studier/MicroNoteStudier.vue
// module id = 708
// module chunks = 1